module.exports = __webpack_public_path__ + "static/media/ic_image_upload_selected.a4a5e8ae.svg";